var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgLogoGeneric(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3236 0.0078125H4.8252C2.26689 0.0078125 0.185547 2.08916 0.185547 4.64747V22.1459C0.185547 24.7042 2.26689 26.7856 4.8252 26.7856H22.3236C24.8819 26.7856 26.9633 24.7042 26.9633 22.1459V4.64747C26.9633 2.08916 24.8819 0.0078125 22.3236 0.0078125ZM25.6377 22.1459C25.6377 23.9733 24.151 25.4599 22.3236 25.4599H4.8252C2.99785 25.4599 1.51118 23.9733 1.51118 22.1459V4.64747C1.51118 2.82011 2.99785 1.33344 4.8252 1.33344H22.3236C24.151 1.33344 25.6377 2.82011 25.6377 4.64747V22.1459ZM16.6447 5.03667L10.5041 9.71509V12.5812L6.94695 15.2914V21.0813H20.2018V12.4254L16.6447 9.7152V5.03667ZM15.3191 7.71323V19.7556H11.8297V10.3717L15.3191 7.71323ZM8.27259 15.948L10.5041 14.2478V19.7557H8.27259V15.948Z",
    fill: "url(#paint0_linear_11711_13996)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11711_13996",
    x1: 1.71755,
    y1: 0.00781224,
    x2: 30.6011,
    y2: 26.7852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20BF6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgLogoGeneric);
export default __webpack_public_path__ + "static/media/org-logo-generic.ebc6b06698c5e883511aead6fb2125ec.svg";
export { ForwardRef as ReactComponent };